import { TextBlock } from '../../model'

class Paragraph extends TextBlock {}

Paragraph.type = "paragraph"

export default Paragraph
